// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lightbox-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: lightboxFadeIn 0.2s ease;
}

@keyframes lightboxFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.lightbox-container {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lightbox-image {
  max-width: 100%;
  max-height: 90vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  -webkit-user-select: none;
          user-select: none;
}

.lightbox-close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 32px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s ease;
  z-index: 10001;
}

.lightbox-close:hover {
  filter: invert(100%);
  transition: 0.3s; /* Adds a smooth transition */
}

.lightbox-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 40px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s ease;
  z-index: 10000;
}

.lightbox-nav:hover {
  filter: invert(100%);
  transition: 0.3s; /* Adds a smooth transition */
}

.lightbox-prev {
  left: 20px;
}

.lightbox-next {
  right: 20px;
}

.lightbox-counter {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  z-index: 10001;
}

@media (max-width: 768px) {
  .lightbox-nav {
    width: 50px;
    height: 50px;
    font-size: 32px;
  }

  .lightbox-prev {
    left: 10px;
  }

  .lightbox-next {
    right: 10px;
  }

  .lightbox-close {
    width: 45px;
    height: 45px;
    font-size: 28px;
    top: 10px;
    right: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Lightbox/Lightbox.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,WAAW;EACb;AACF","sourcesContent":[".lightbox-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.95);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9999;\r\n  animation: lightboxFadeIn 0.2s ease;\r\n}\r\n\r\n@keyframes lightboxFadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.lightbox-container {\r\n  position: relative;\r\n  max-width: 90vw;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.lightbox-image {\r\n  max-width: 100%;\r\n  max-height: 90vh;\r\n  width: auto;\r\n  height: auto;\r\n  object-fit: contain;\r\n  border-radius: 8px;\r\n  user-select: none;\r\n}\r\n\r\n.lightbox-close {\r\n  position: absolute;\r\n  top: 20px;\r\n  right: 20px;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border: none;\r\n  color: white;\r\n  font-size: 32px;\r\n  width: 50px;\r\n  height: 50px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  transition: background 0.2s ease;\r\n  z-index: 10001;\r\n}\r\n\r\n.lightbox-close:hover {\r\n  filter: invert(100%);\r\n  transition: 0.3s; /* Adds a smooth transition */\r\n}\r\n\r\n.lightbox-nav {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border: none;\r\n  color: white;\r\n  font-size: 40px;\r\n  width: 60px;\r\n  height: 60px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  transition: background 0.2s ease;\r\n  z-index: 10000;\r\n}\r\n\r\n.lightbox-nav:hover {\r\n  filter: invert(100%);\r\n  transition: 0.3s; /* Adds a smooth transition */\r\n}\r\n\r\n.lightbox-prev {\r\n  left: 20px;\r\n}\r\n\r\n.lightbox-next {\r\n  right: 20px;\r\n}\r\n\r\n.lightbox-counter {\r\n  position: absolute;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  color: white;\r\n  padding: 8px 12px;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  z-index: 10001;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .lightbox-nav {\r\n    width: 50px;\r\n    height: 50px;\r\n    font-size: 32px;\r\n  }\r\n\r\n  .lightbox-prev {\r\n    left: 10px;\r\n  }\r\n\r\n  .lightbox-next {\r\n    right: 10px;\r\n  }\r\n\r\n  .lightbox-close {\r\n    width: 45px;\r\n    height: 45px;\r\n    font-size: 28px;\r\n    top: 10px;\r\n    right: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
